import React from 'react';

const PhysicalDescriptionForm = ({ formData, setFormData }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value || null }));
    };

    return (
        <fieldset className="p-3 border border-gray-300 rounded-md space-y-2">
            <legend className="px-2 text-sm font-semibold text-gray-700">Servee / Substitute Physical Description</legend>
            <div className="grid grid-cols-2 gap-3">
                <input type="text" name="sex" placeholder="Sex (e.g., Male)" value={formData.sex || ''} onChange={handleChange} className="input-field p-1 pl-2 border border-gray-300 rounded " />
                <input type="text" name="race" placeholder="Race (e.g., Caucasian)" value={formData.race || ''} onChange={handleChange} className="input-field p-1 pl-2 border border-gray-300 rounded " />
                <input type="number" name="age" placeholder="Age (Approx)" value={formData.age || ''} onChange={handleChange} className="input-field p-1 pl-2 border border-gray-300 rounded " />
                <input type="text" name="height" placeholder="Height (e.g., 5'10&quot;)" value={formData.height || ''} onChange={handleChange} className="input-field p-1 pl-2 border border-gray-300 rounded " />
                <input type="text" name="weight" placeholder="Weight (Approx)" value={formData.weight || ''} onChange={handleChange} className="input-field p-1 pl-2 border border-gray-300 rounded " />
                <input type="text" name="hair" placeholder="Hair Color/Style" value={formData.hair || ''} onChange={handleChange} className="input-field p-1 pl-2 border border-gray-300 rounded " />
            </div>
            <textarea
                name="other_identifiers"
                rows="2"
                placeholder="Other Identifiers (e.g., Tattoos, glasses, clothing details)"
                value={formData.other_identifiers || ''}
                onChange={handleChange}
                className="input-field p-1 pl-2 border border-gray-300 rounded  w-full "
            />
        </fieldset>
    );
};

export default PhysicalDescriptionForm;